import React from 'react'
import stepperoneStyle from './RegistermobilStepOne.module.css'

export default function RegistermobilStepOne() {
    return (
        <>
            <div className={stepperoneStyle.stepperOne}>
                <div className='row'>
                    <div className='col-7'>
                        <h3> Welcome Coordinator </h3>
                    </div>
                    <div className='col-5'>
                        <div className={stepperoneStyle.profileBox}>
                            <div className={stepperoneStyle.profileImg}>
                                <div className={stepperoneStyle.profileImginner}>
                                    <img src="/static/media/lady-img.965cec88308ed5853d74.png" className="img-fluid w-100 h-100 rounded-circle" />
                                </div>
                            </div>
                            <div className={stepperoneStyle.profileeditBox}>
                                <input type="file" className={stepperoneStyle.profilechooseInput} accept=".png, .jpg, .jpeg" />
                                <label className={stepperoneStyle.profileLabel} for="imageUpload" />
                            </div>
                        </div>
                    </div>
                </div>
                <h6> Sign up to join </h6>
                <h5> Coordinator Information </h5>
                <div className='row'>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="text" className={`${stepperoneStyle.oneInput} form-control`} placeholder='First Name' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="text" className={`${stepperoneStyle.oneInput} form-control`} placeholder='Last Name' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="text" className={`${stepperoneStyle.oneInput} form-control`} placeholder='Position' />
                        </div>
                    </div>
                    <div className='col-12'>
                        <div className="mb-3">
                            <input type="email" className={`${stepperoneStyle.oneInput} form-control`} placeholder='Email Address' />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
